import React from "react";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { navigate } from "@reach/router";
import { Icon, Button, Spin } from "antd";
import axios from "axios";
import publicIp from "public-ip";
import { AuthService } from "../../services/AuthService.ts";
import { captureException } from "../../utils/sentry";
import Header from "./Components/Header";
import Jumbotron from "./Components/Jumbotron";
import Body from "./Components/Body";
import ReadyBlock from "./Components/ReadyBlock";
import Footer from "./Components/Footer";
import { SlideBar } from "./Components/styles";
import { getAllCountries } from "../../graphQl/queries/countries";
import { redirectToDashboardForRole } from "../../utils/authRedirect";

const authService = new AuthService();

const loadingStyle = {
  width: "100%",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

class Landing extends React.Component {
  state = {
    changeScroll: false,
    widthSlidebar: false,
    currentCountryInfo: null,
    countriesData: null,
    checkingSession: true,
    loadingText: "Cargando...",
  };

  mounted = false;

  componentDidMount() {
    this.mounted = true;
    window.addEventListener("scroll", this.handleScroll);
    this.init();
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener("scroll", this.handleScroll);
  }

  safeSetState = state => this.mounted && this.setState(state);

  init = async () => {
    const { location } = this.props;
    const { navigateLogin } = location.state || {};
    const shouldLogin =
      navigateLogin || new URLSearchParams(location.search).get("login") === "true";

    this.getCountries(); // en paralelo, no bloquea la pantalla

    try {
      const user = await authService.getUser();
      if (user) {
        this.safeSetState({ loadingText: "Redirigiendo a tu panel..." });
        await redirectToDashboardForRole(this.props.client, user.profile.sub);
        return; // el spinner se mantiene mientras navega
      }
      if (shouldLogin) {
        this.safeSetState({ loadingText: "Redirigiendo al inicio de sesión..." });
        await authService.login();
        return; // el spinner se mantiene mientras sale a Keycloak
      }
    } catch (err) {
      captureException(err);
    }
    this.safeSetState({ checkingSession: false });
  };

  getCountries = async () => {
    this.getCountryFromIP();
    try {
      const { data } = await this.props.client.query({
        fetchPolicy: "network-only",
        query: getAllCountries,
      });
      this.safeSetState({ countriesData: data.GetAllCountries });
    } catch (err) {
      captureException(err);
    }
  };

  getCountryFromIP = async () => {
    try {
      const ip = await publicIp.v4();
      const { data } = await axios.get(`https://geolocation-db.com/json/${ip}`);
      this.safeSetState({ currentCountryInfo: data });
    } catch (err) {
      console.log(err);
    }
  };

  handleScroll = event => {
    const changeScroll = event.srcElement.children[0].scrollTop > 1;
    if (changeScroll !== this.state.changeScroll) this.setState({ changeScroll });
  };

  login = () => authService.login();

  register = () => navigate("/create-account");

  toggleSlidebar = () =>
    this.setState(({ widthSlidebar }) => ({ widthSlidebar: !widthSlidebar }));

  render() {
    const {
      checkingSession,
      loadingText,
      widthSlidebar,
      changeScroll,
      countriesData,
      currentCountryInfo,
    } = this.state;

    if (checkingSession) {
      return (
        <div style={loadingStyle}>
          <Spin tip={loadingText} size="large" />
        </div>
      );
    }

    return (
      <div>
        <SlideBar style={{ width: widthSlidebar ? "100%" : 0 }}>
          <img
            className="iconImage"
            alt="chazi icon"
            src="https://firebasestorage.googleapis.com/v0/b/chazki-link.appspot.com/o/nintendo%2FIconsGameboy%2FchazkiIcon.png?alt=media&token=e6a5888e-ff41-4aad-90a9-61d09b862909"
          />
          <Icon
            className="onClickSlidebar"
            onClick={this.toggleSlidebar}
            type="close"
            style={{ fontSize: 27, color: "#307fe2" }}
          />
          <div className="containerSlidebar">
            <a href="/">Afiliados</a>
            <a href="/">Servicios</a>
            <a href="/">Partners</a>
            <Button onClick={this.register}>Registrate</Button>
            <Button onClick={this.login}>Inicia Sesión</Button>
          </div>
        </SlideBar>
        <Header
          login={this.login}
          register={this.register}
          changeScroll={changeScroll}
          onClickheader={this.toggleSlidebar}
        />
        <Jumbotron />
        <Body countriesData={countriesData} currentCountryInfo={currentCountryInfo} />
        <ReadyBlock />
        <Footer />
      </div>
    );
  }
}

export default compose(withApollo)(Landing);